var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sponsors-categories",attrs:{"id":"sp"}},_vm._l((_vm.categories),function(ref,index){
var name = ref.name;
var id = ref.id;
return _c('div',{key:id,staticClass:"sponsor-category mt-1 mb-2"},[_c('div',{staticClass:"sponsorHeading"},[_c('h3',{staticClass:"sponsor-font"},[_vm._v(_vm._s(name))])]),_c('Sponsors',{attrs:{"categoryId":id,"index":index,"categoryName":name}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }